<template>
  <f7-page class="bg-color-white">
    <f7-block class="text-align-center margin-top-half margin-bottom-half">
      <f7-link href="/" panel-close>
        <img src="static/shmu/img/shmu.svg" class="img-logo-panel">
      </f7-link>
    </f7-block>
    <f7-list accordion-list class="margin-top-half shmu-menu">
      <f7-list-item class="shmu-m-level" link="/" panel-close title="Úvodná obrazovka" no-chevron media="static/shmu/img/home.svg"></f7-list-item>
      <f7-list-item class="shmu-m-level shmu-i-pocasie" accordion-item title="Počasie" media="static/shmu/img/sun.svg">
        <f7-accordion-content>
          <f7-list>
            <f7-list-item class="shmu-s-level" link="/aktualne-pocasie/" panel-close no-chevron title="Aktuálne počasie"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/predpoved-pocasia/" panel-close no-chevron title="Modelová predpoveď"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/textova-predpoved/" panel-close no-chevron title="Textová predpoveď"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/meteogramy/" panel-close no-chevron title="Meteogramy"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/a-laef/" panel-close no-chevron title="A-LAEF"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/radary/" panel-close no-chevron title="Radary"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/druzice/" panel-close no-chevron title="Družice"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/meteo-vystrahy/" panel-close no-chevron title="Meteo výstrahy"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/tlakove-pole/" panel-close no-chevron title="Tlakové pole"></f7-list-item>
            <f7-list-item v-if="showSnowInfo" class="shmu-s-level" link="/snehove-spravodajstvo/" panel-close no-chevron title="Snehové spravodajstvo"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/ozon/" panel-close no-chevron title="Ozón"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/uv-index/" panel-close no-chevron title="UV index"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/webkamery/" panel-close no-chevron title="Web kamery"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/radioaktivita/" panel-close no-chevron title="Rádioaktivita"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/meteo-sucho/" panel-close no-chevron title="Meteorologické sucho"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/lms-metar/" panel-close no-chevron title="METAR"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/lms-taf/" panel-close no-chevron title="TAF"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/lms-sigmet/" panel-close no-chevron title="SIGMET"></f7-list-item>
            <f7-list-item class="shmu-s-level" link="/lms-surfana/" panel-close no-chevron title="SURFANA"></f7-list-item>
          </f7-list>
        </f7-accordion-content>
      </f7-list-item>
      <f7-list-item class="shmu-m-level shmu-i-vodne-zdroje"  accordion-item title="Voda"  media="static/shmu/img/wave.svg">
        <f7-accordion-content>
          <f7-list>
            <f7-list-item class="shmu-s-level shmu-ii-vodne-stavy" link="/vodne-stavy/" panel-close no-chevron title="Vodné stavy"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-uhrny-zrazok" link="/uhrny-zrazok/" panel-close no-chevron title="Úhrny zrážok"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-hydro-vystrahy" link="/hydro-vystrahy/" panel-close no-chevron title="Hydro výstrahy"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-hydro-spravodajstvo" link="/hydro-spravodajstvo/" panel-close no-chevron title="Hydrologické spravodajstvo"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-hydro-situacia" link="/hydro-situacia/" panel-close no-chevron title="Hydrologická situácia"></f7-list-item>
            <f7-list-item v-if="showWaterTanks" class="shmu-s-level shmu-ii-hydro-nadrze" link="/hydro-nadrze/" panel-close no-chevron title="Teploty vodných nádrží"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-situacia-na-vodnych-tokoch" link="/situacia-na-vodnych-tokoch/" panel-close no-chevron  title="Sucho v povrchových vodách"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-podzemne-vody" link="/podzemne-vody/" panel-close no-chevron title="Sucho v podzemných vodách"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-pzv-dyn" link="/kvalita-podzemnej-vody/" panel-close no-chevron title="Kvalita podzemnej vody"></f7-list-item>
          </f7-list>
        </f7-accordion-content>
      </f7-list-item>
      <f7-list-item class="shmu-m-level shmu-i-kvalita-ovzdusia"  media="static/shmu/img/plant.svg" accordion-item title="Kvalita ovzdušia">
        <f7-accordion-content>
          <f7-list>
            <f7-list-item class="shmu-s-level shmu-ii-smogovy-varovny-system"  link="/smogovy-system/" panel-close no-chevron title="Smogový varovný systém"></f7-list-item>
            <f7-list-item class="shmu-s-level shmu-ii-ko-tabulka"  link="/kvalita-ovzdusia/" panel-close no-chevron title="Aktuálne koncentrácie"></f7-list-item>
          </f7-list>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>
<script>

  export default {
    data() {
      return {

      }
    },
    computed: {
      showSnowInfo() {
        let rok = new Date().getFullYear();
        let aboveOctober =  new Date(rok, 9, 1); // mesiac -1, teda od 1.10
        let belowMay = new Date(rok, 4, 30); // mesiac -1, teda do 30.5
        let currentDate = new Date();

        if (currentDate <= belowMay) {
          return true;
        }

        if (currentDate >= aboveOctober) {
          return true;
        }

        return false;
      },

      showWaterTanks() {
        let rok = new Date().getFullYear();
        let bellowOctober =  new Date(rok, 9, 1); // mesiac -1, teda od 1.10
        let abovebMay = new Date(rok, 4, 30); // mesiac -1, teda do 30.5
        let currentDate = new Date();

        if (currentDate > abovebMay) {
          return true;
        }

        if (currentDate <= bellowOctober) {
          return true;
        }

        return false;
      }
    }
  }
</script>

<style lang="scss">

  .img-logo-panel {
    width: 100%;
    height:auto;
    max-width:70%;
    margin: 1rem auto;
  }

  .shmu-menu {

    .item-media {
      img {
        width: 38px;
      }
    }
    .shmu-m-level {
      .item-inner {
        &:after {
          display: none;
        }
      }

      &:after {
        content: '';
        position: absolute;
        background-color: var(--f7-list-border-color);
        display: block;
        z-index: 15;
        top: auto;
        right: auto;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        transform-origin: 50% 100%;
        transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
      }
      &:last-child {
        &:after {
          display: none;
        }
      }

      &.accordion-item-opened {
        .item-title {
          font-weight: bold;
        }
      }


    }



    .shmu-s-level {
      &:hover,
      &.active {
        background-color: var(--f7-color-blue-shade);
        .item-title {
          /* font-weight:bold !important; */
          color: white;
        }
      }
      .item-inner {
        &:after {
          display: block;
        }
        .item-title {
          font-size: 90%;
          font-weight: normal;
        }
      }
    }

  }

</style>

